<template>
  <div class="hero-container">
    <div class="use-cases-section">
      <div class="container">
        <h2>Use Cases</h2>
        <div class="explore">
          <div class="images-section">
            <div
              class="product-card photon-card"
              v-for="pano in panoramas"
              :key="pano.id"
            >
              <div class="card-image">
                <div class="pano_layer"></div>
                <DemoViewer
                  :panoId="pano.class"
                  :imageSrc="`${baseUrl}/${pano.id}`"
                />
              </div>
              <div class="card-content">
                <div class="card-header">
                  <div class="logo-container">
                    <h1>{{ pano.title }}</h1>
                  </div>
                </div>
                <p class="product-description">
                  {{ pano.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import logger from "debug";
import DemoViewer from "../viewer/DemoViewer.vue";
import { onMounted } from "vue";
const debug = logger("travvir:enterprises:HeroMazipano");
//variables
const config = useRuntimeConfig();
const panoramas = [
  {
    class: "explorePano1",
    id: "61fcc50f0428aba3fd5dce60/4b2dd0db-30ab-486b-bf75-9ab8f6b40c36",
    name: "Hotel Room(TEk0ZaPBLv)",
    title: "Travel & Hospitality",
    description:
      "Hotels, Resorts, Villas, OTAs, Tour Operators, DMCs, B&Bs, Vacation Rentals",
  },
  {
    class: "explorePano2",
    id: "682c31c4ece8ca2fc66670e5/9576cf27-d2ec-46ca-bf2d-9efe9ebb9682",
    name: "Restaurant",
    title: "Restaurants & Dining",
    description:
      "  Restaurant Chains, Independent Restaurants, Cafes, Bars, Food Courts, Catering",
  },
  {
    class: "explorePano3",
    id: "61fcc50f0428aba3fd5dce60/ac5b4275-a1d2-426a-88a0-201e65405ac0",
    name: "Gym(SoAD0NVqMO)",
    title: "Fitness & Wellness",
    description:
      "Gyms, Fitness Centers, Yoga Studios, Spas, Salons, Wellness Centers, Sports Clubs",
  },
  {
    class: "explorePano4",
    id: "67b83c0fb5b6da2b18cb7e95/defd4948-ce49-465b-8d96-4171f02f73b3",
    name: "Sitting Area",
    title: "Real Estate",
    description:
      "Realtors, Property Managers, Landlords, Office Spaces, Coworkings, Marketplaces",
  },
  {
    class: "explorePano5",
    id: "651f85af619e7c4b109ff851/534bba1f-d7c3-48bc-b4f4-9c067aa57301",
    name: "Shopping Mart",
    title: "Retail",
    description:
      "Stores, Malls, Showrooms, Car Dealerships, Fashion Boutiques, Electronics Retailers",
  },
  {
    class: "explorePano6",
    id: "62418a08c6067232263b61aa/cb05a43a-9adf-4ba0-af01-97f284f065c1",
    name: "Indoors 1",
    title: "Industrial & Warehousing",
    description: "Factories, logistics hubs, warehouses, showrooms.",
  },
  {
    class: "explorePano7",
    id: "666191b7d45d6954a987415a/67aa97e1-d7a8-4fe3-964c-02ab5e76558f",
    name: "Bar Sitting Area",
    title: "Events & Entertainment",
    description:
      "Banquets, wedding venues, concert halls, theaters, stadiums, convention centers.",
  },
];

//computed
const baseUrl = computed(() => config.public.NUXT_CDN_URL);
onMounted(async () => {
  // await init();
});
</script>
<style lang="scss" scoped>
.container {
  font-family: "Book21", "Sharp Grotesk", sans-serif;
  /* fallback */
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem;
}
.use-cases-section {
  padding: 2rem 0;

  @include respond-below(sm) {
    padding: 3rem 0;
  }

  h2 {
    text-align: center;
    font-size: clamp(2rem, 5vw, 3rem);
    font-weight: $fw-semibold;
    margin: 0 0 5rem 0;
    line-height: 1.2;
    letter-spacing: -0.021em;

    @include respond-below(sm) {
      margin-bottom: 2rem;
    }
  }
}

.explore {
  display: flex;
  gap: 2rem;
  flex-direction: column;
  width: 100%;
}
.images-section {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  height: fit-content;
  @include respond-below(md) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}

.product-card {
  height: fit-content;
  width: 100%;
  background: linear-gradient(
    145deg,
    rgba(255, 255, 255, 0.1),
    rgba(255, 255, 255, 0.05)
  );
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 24px;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(20px);
  position: relative;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-12px);
    border-color: rgba(255, 255, 255, 0.25);
    box-shadow: 0 32px 64px rgba(0, 0, 0, 0.3);

    .card-image iframe {
      transform: scale(1.02);
    }
  }

  &.photon-card {
    background: linear-gradient(
      145deg,
      rgba(21, 21, 21, 0.9),
      rgba(15, 15, 15, 0.8)
    );
    border-color: rgba(255, 255, 255, 0.1);
  }

  &.ray-card {
    background: linear-gradient(
      145deg,
      rgba(21, 21, 21, 0.9),
      rgba(15, 15, 15, 0.8)
    );
    border-color: rgba(255, 255, 255, 0.1);
  }

  &.photon-card-1 {
    width: 100%;
    @include respond-below(lg) {
      width: 100%;
    }
    &.without-bg {
      background-color: transparent;
    }
  }
}

.card-image {
  width: 100%;
  height: 430px;
  overflow: hidden;
  position: relative;
  @include respond-below(sm) {
    height: 260px;
  }

  iframe {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.4s ease;
    border-radius: inherit;
  }
}

.card-content {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  .card-header {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    margin-bottom: 0;

    .logo-container {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      min-height: 60px;

      @include respond-below(sm) {
        min-height: 50px;
      }

      h1 {
        font-size: 1.5rem;
        font-weight: 700;
        margin: 0;
        color: white;
        letter-spacing: -0.02em;
        line-height: 1.2;

        @include respond-below(sm) {
          font-size: 1.3rem;
        }
      }

      .company-logo {
        max-height: 50px;
        max-width: 180px;
        width: auto;
        height: auto;
        object-fit: contain;
        filter: brightness(1.2) contrast(1.1);
        transition: all 0.3s ease;

        @include respond-below(sm) {
          max-height: 40px;
        }

        &:hover {
          transform: scale(1.05);
          filter: brightness(1.4) contrast(1.2);
        }
      }
    }
  }

  .product-title {
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0;
    color: white;
    letter-spacing: -0.02em;

    @include respond-below(sm) {
      font-size: 1.5rem;
    }
  }

  .product-description {
    font-size: 1rem;
    line-height: 1.4;
    margin: 0;
    color: rgba(255, 255, 255, 0.7);
    font-weight: 400;

    @include respond-below(sm) {
      font-size: 0.9rem;
    }
  }

  .discover-btn {
    display: none;
    text-decoration: none;
    background: white;
    color: #000;
    border: none;
    padding: 12px 24px;
    border-radius: 25px;
    cursor: pointer;
    font-size: 0.95rem;
    font-weight: 600;
    transition: all 0.3s ease;
    width: fit-content;
    margin-top: 0.5rem;

    &:hover {
      background: rgba(255, 255, 255, 0.9);
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(255, 255, 255, 0.2);
    }

    &:active {
      transform: translateY(0);
    }
  }
}

@media (prefers-color-scheme: dark) {
  .research-section {
    background: #000;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.research-content {
  animation: fadeInUp 0.6s ease-out;
}

// Responsive typography improvements
@media (max-width: 480px) {
  .research-section {
    padding: 3rem 0;
  }

  .container {
    padding: 0 1rem;
  }

  .research-content {
    gap: 2rem;
  }

  .text-section {
    gap: 2.5rem;
  }

  .main-text h2 {
    font-size: 1.5rem;
    line-height: 1.3;
  }

  .description-text p {
    font-size: 0.95rem;
  }
}

#explorePano1,
#explorePano2,
#explorePano3,
#explorePano4,
#explorePano5,
#explorePano6,
#explorePano7 {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
  border-radius: 10px;
  @include respond-below(sm) {
    width: 100%;
    height: 100%;
  }
}
.pano_layer {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 2;
  border-radius: 10px;
  @include respond-below(sm) {
    width: 100%;
  }
}
.more-industries-card {
  background: linear-gradient(145deg, #24242458, rgba(74, 74, 74, 0.267));
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;

  &:hover {
    border: 1px solid rgba(138, 43, 226, 0.3);
    box-shadow: 0 15px 30px rgba(138, 43, 226, 0.4);
  }
}
.more-content {
  text-align: center;
  padding: 2rem;

  .more-icon {
    margin-bottom: 1.5rem;

    .plus-icon {
      width: 60px;
      height: 60px;
      background: radial-gradient(
        55.95% 97.37% at 46.69% 2.63%,
        // #ffb571 0,
        // #477ff4 36.01%,
        #4d4e4d 36.01%,
        // #c2cbfe
      );
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 2rem;
      font-weight: bold;
      color: white;
      margin: 0 auto;
      transition: transform 0.3s ease;
    }

    &:hover .plus-icon {
      transform: scale(1.1) rotate(90deg);
      border: 1px solid rgba(138, 43, 226, 0.3);
      box-shadow: 0 15px 30px rgba(138, 43, 226, 0.4);
    }
  }

  h2 {
    font-size: 2rem;
    font-weight: 700;
    color: white;
    margin-bottom: 0.8rem;
    background: radial-gradient(
      55.95% 97.37% at 46.69% 2.63%,
      // #ffb571 0,
      rgba(138, 43, 226, 0.4) 19.27%,
      #fff 82.09%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    @include respond-below(sm) {
      font-size: 1.2rem;
    }
  }

  .starter-line {
    font-size: 1.1rem;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 1.2rem;
    line-height: 1.3;
  }

  .more-description {
    font-size: 1rem;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 1.5rem;
    max-width: 280px;
    margin-left: auto;
    margin-right: auto;
  }

  .contact-prompt {
    span {
      font-size: 0.9rem;
      color: rgba(255, 255, 255, 0.6);
      font-style: italic;
    }
  }
}
</style>
